
import { useState, useEffect } from 'react';

const FORM_STORAGE_KEY = 'grievance-form-data';

export function useFormPersistence() {
  const saveFormData = (formData: Record<string, unknown>) => {
    try {
      localStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(formData));
    } catch (error) {
      console.error('Error saving form data:', error);
    }
  };

  const loadFormData = () => {
    try {
      const savedData = localStorage.getItem(FORM_STORAGE_KEY);
      return savedData ? JSON.parse(savedData) : null;
    } catch (error) {
      console.error('Error loading form data:', error);
      return null;
    }
  };

  const clearFormData = () => {
    try {
      localStorage.removeItem(FORM_STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing form data:', error);
    }
  };

  return {
    saveFormData,
    loadFormData,
    clearFormData
  };
}
